import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[wfdssRemoveSpaceOnly]',
    standalone: false
})
export class RemoveSpaceOnlyDirective {

  constructor(private el: ElementRef, 
  @Optional() @Self() private ngControl: NgControl | null
  ) { }

  @HostListener('input') onBlur() {
    const inputVal = this.el.nativeElement.value.trim();
    
    // replace 'space only' with empty string for 'required' field validation to kick in
    if(inputVal?.trim() === '') {
      this.el.nativeElement.value = '';
      this.ngControl?.control?.setValue('');
    }
    
  }

}
